// i18n
import { translateInComponent } from 'infras/i18n';
import translations from 'presentations/views/components/pages/ChangelogListPage/i18n.json';

import { ChangeEvent, useContext } from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

import MainDocument from 'presentations/views/components/MainDocument';
import { apiPath, changelogListPath, webPath } from 'presentations/routes/path';
import { get } from 'infras/rest_client';
import { ChangelogListItem } from 'presentations/api/schema/contents';
import Header from 'presentations/views/components/organisms/Header';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import ChangelogListPage from 'presentations/views/components/pages/ChangelogListPage';

interface ServerProps {
  changelogs: ChangelogListItem[];
  currentPage: number;
  numberOfPages: number;
  linkCanonical: string;
}

export const getServerSideProps: GetServerSideProps = async ({
  req,
  locale,
}: any) => {
  const page = req.query.page || null;

  const result = await get(apiPath(`/v1/contents/changelog`, { page, locale }));
  if (!result.isSuccess) {
    return { props: { statusCode: 404 } };
  }
  if (!result.data) {
    return { props: { statusCode: 404 } };
  }
  const changelogs: ChangelogListItem[] = result.data;
  const currentPage = result.currentPage ? Number(result.currentPage) : 1;
  const props: ServerProps = {
    changelogs,
    currentPage,
    numberOfPages: result.numberOfPages ? Number(result.numberOfPages) : 0,
    linkCanonical: webPath(
      changelogListPath({
        page: currentPage > 1 ? currentPage : undefined,
      }),
      locale,
    ),
  };
  return { props };
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const { state: serviceState } = useContext(ServicePortalContext);
  const router = useRouter();
  const title = t('title');
  const breadcrumbs = [];
  breadcrumbs.push({
    title: t('title'),
    link: changelogListPath(),
  });

  const onChangePage = (e: ChangeEvent, value: number) => {
    const options = { page: value };
    router.push(changelogListPath(options));
    window.scrollTo(0, 0);
  };

  return (
    <MainDocument
      title={title}
      description={''}
      linkCanonical={props.linkCanonical}
    >
      <ChangelogListPage
        title={title}
        breadcrumbs={breadcrumbs}
        changelogs={props.changelogs}
        header={<Header viewer={serviceState.viewer} />}
        paginationProps={{
          currentPage: props.currentPage,
          numberOfPages: props.numberOfPages,
          onChange: onChangePage,
        }}
      />
    </MainDocument>
  );
}
